<template>
  <div>
    <v-container fluid >
      <v-row no-gutters>
        <v-col cols="12">
          <p class="grey lighten-2 pa-2">
            <span class="font-weight-black ">Descripción:</span>
            <br>
            <span ma-5>Este Campo permite invocar un Sub Formulario, 
                el cual permite adicionar información al formulario pricipal en una sección.</span>
          </p>
        </v-col> 
        <v-col cols="12">
          <v-autocomplete
            v-model="subFormulario"
            :items="aSubFormulario"
            item-text="NombreSubFormulario"
            item-value="idFD_SubFormulario"
            dense
            filled
            label="Sub Formulario"
          ></v-autocomplete>
        </v-col>
         <v-col cols="12" align-end>
          <span>Obligatorio</span>
          <v-radio-group v-model="obligatorio" row >
            <v-radio
              label="SI"
              value="1"
            ></v-radio>
            <v-radio
              label="NO"
              value="0"
            ></v-radio>
          </v-radio-group>
        </v-col>  
      </v-row>  
      <v-row no-gutters>
        <v-col cols="12" align-end v-if="errors.length" style="font-size: 12px;" class="red--text">
          <p >
            <b>Por favor, corrija el(los) siguiente(s) error(es):</b>
            <ul>
              <li v-for="(error, key) in errors" :key="key">{{ error }}</li>
            </ul>
          </p>
        </v-col>  
        <v-col cols="12" align-end>
          <v-btn block color="btncolor" elevation="2" dark @click="Guardar">
           <h2> Guardar </h2>
          </v-btn>
        </v-col> 
      </v-row>  
    </v-container>   
  </div>
</template>

<script>
import axiosServices from '@/services/axiosServices.js'

export default {
  name:"ItemConfig",
  props: {
    campos: {
      type: Object,
      required: true
    },
    camposIndex: {
      type: Number,
      required: true
    }, 
  },
  data() {
    return {
      subFormulario  : '',
      aSubFormulario : [],
      obligatorio: '',
      errors: [],
    }
  },
  mounted () {
    this.getPreguntas()
    this.cargarDatos()
  },
  methods: {
    async getPreguntas() {
      const axiosSubForm = await axiosServices.getConfiguration('buildDinamicos/subformulario', true )
      this.aSubFormulario = axiosSubForm.aData
    },
    validarInfo(){

      this.errors = []

      if(this.subFormulario == ''){
       this.errors.push('Debe Seleccionar una sub formulario!')
      }

      // valido si el grupo no esta repetida
      const auxboard = this.$store.state.board.columns[1].campos
     
      const preguntaIndex = auxboard.findIndex(campo =>
        ( campo.idPregunta == this.subFormulario && campo.NombreTipo == "Item")
      )

      if(preguntaIndex != this.camposIndex && preguntaIndex > -1){
       this.errors.push('El subFormulario seleccionada esta en otro campo, No la puede emplear!')
      }


      if( this.errors.length==0){
        return false 
      } else {
        return true 
      }

    },
    Guardar(){

      if( this.validarInfo() ){
        return
      }

      const auxsubFormularios = this.aSubFormulario.filter( subForm => subForm.idFD_SubFormulario == this.subFormulario )


      const auxcampo = {
          id: this.campos.id,
          ancho: this.campos.ancho,
          userAssigned: this.campos.userAssigned,
          idTipoCampo: this.campos.idTipoCampo,
          NombreTipo: this.campos.NombreTipo,
          name: this.campos.name,
          idPregunta: this.subFormulario ,
          pregunta: auxsubFormularios[0].NombreSubFormulario,
          obligatorio: this.obligatorio,
          valor: this.campos.valor ,
      }

      this.$store.dispatch('salvarCampoBoard',{camposIndex:this.camposIndex, campo:auxcampo })

    },
    cargarDatos() {
      this.errors = []
      this.subFormulario = this.campos.idPregunta == 0 ? 0 : this.campos.idPregunta
      this.obligatorio = 0
    }
  },
  watch: {
    camposIndex(newValue, oldValue) {
      if (newValue !== oldValue){
        this.cargarDatos()
      }

      
    }
  },
}
</script>

<style lang="scss" scoped>

</style>